<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>{{message}}</mat-dialog-content>
<mat-dialog-actions class="flex row end-center">
  <button mat-button mat-dialog-close color="primary">OK</button>
</mat-dialog-actions>
